import { Global } from '@emotion/react'
import * as React from 'react'

const Fonts = () => (
  <Global
    styles={`
      /* latin */
      @font-face {
      font-family: 'DINPro';
      font-weight: normal;
      font-style: normal;
        font-display: swap;
        src: url('../fonts/DINPro.woff2') format('woff2'), url('../fonts/DINPro.woff') format('woff');
      }
      /* latin */
       @font-face {
      font-family: 'DINPro Thin';
      font-weight: 100;
      font-style: normal;
        font-display: swap;
        src: url('../fonts/DINPro-Thin.woff2') format('woff2'), url('../fonts/DINPro-Thin.woff') format('woff');
      }
      /* latin */
      @font-face {
      font-family: 'DINPro Medium';
      font-weight: 500;
      font-style: normal;
        font-display: swap;
        src: url('../fonts/DINPro-Medium.woff2') format('woff2'), url('../fonts/DINPro-Medium.woff') format('woff');
      }
     /* latin */
      @font-face {
      font-family: 'DINPro Light';
      font-weight: 300;
      font-style: normal;
        font-display: swap;
        src: url('../fonts/DINPro-Light.woff2') format('woff2'), url('../DINPro-Light.woff') format('woff');
      }
         /* latin */
      @font-face {
      font-family: 'DINPro Black';
      font-weight: 900;
      font-style: normal;
        font-display: swap;
        src: url('../fonts/DINPro-Black.woff2') format('woff2'), url('../DINPro-Black.woff') format('woff');
      }
      `}
  />
)

export default Fonts